import axios from 'axios'
import {AUTH_LOG_USER_OUT, SET_INVALID_TOKEN} from "@/store/action-types";
import auth from "@/store/modules/auth";
import store from '@/store'
import router from '@/router'
import {IS_DELETE_CONFIRMATION, IS_ORDER_CONFIRMATION} from "@/store/getter-types";

function addDefaultHeadersInterceptor (config: any): any {
  config.headers.get['Accept'] = 'application/json'

  if (config.method && config.headers && config.headers[config.method]) {
    config.headers[config.method]['Authorization'] = 'Bearer ' + localStorage.getItem('token')
  }

  return config
}

const config = {
  baseURL: process.env.VUE_APP_API_ROOT
}

const instance = axios.create(config)

instance.interceptors.request.use(addDefaultHeadersInterceptor)

instance.interceptors.response.use(function (response) {
  return response
}, function (error) {
  const isOrderConfirmation: boolean = store.getters[IS_ORDER_CONFIRMATION]
  const isDeleteConfirmation: boolean = store.getters[IS_DELETE_CONFIRMATION]
  if (error.response.status === 401 && !isOrderConfirmation && !isDeleteConfirmation) {
    if (auth.state.currentUser) {
      store.dispatch(SET_INVALID_TOKEN,true)
    }
    store.dispatch(AUTH_LOG_USER_OUT)
    router.push({ name: 'Login' })
  }
  return Promise.reject(error)
})

export default instance
